import React, { useEffect, useState } from "react";
import {
  Container,
  Typography,
  Grid,
  Paper,
  Box,
  IconButton,
  Menu,
  MenuItem,
  TextField,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Snackbar,
  Alert,
  InputAdornment,
} from "@mui/material";
import { SpeedDial, SpeedDialAction, SpeedDialIcon } from "@mui/material";
import FolderIcon from "@mui/icons-material/CreateNewFolder";
import InventoryIcon from "@mui/icons-material/Inventory2";
import PhotoCameraIcon from "@mui/icons-material/PhotoCamera";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import AddIcon from "@mui/icons-material/Add";
import CheckIcon from "@mui/icons-material/Check";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import SaveIcon from "@mui/icons-material/Save";
import CloseIcon from "@mui/icons-material/Close";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import DriveFileMoveIcon from "@mui/icons-material/DriveFileMove";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import SearchIcon from "@mui/icons-material/Search";
import axios from "axios";
import StorefrontIcon from "@mui/icons-material/Storefront";
import { useNavigate, useParams } from "react-router-dom";
import AutorenewIcon from "@mui/icons-material/Autorenew";

function MobileStocManager() {
  const [summary, setSummary] = useState({
    folders: 0,
    products: 0,
    items: 0,
    totalValue: 0,
  });
  const [folders, setFolders] = useState([]);
  const [products, setProducts] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedFolder, setSelectedFolder] = useState(null);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [editingId, setEditingId] = useState(null);
  const [editedName, setEditedName] = useState("");
  const [dialogOpen, setDialogOpen] = useState(false);
  const [newFolderName, setNewFolderName] = useState("");
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [groupName, setGroupName] = useState("");
  const [productDialogOpen, setProductDialogOpen] = useState(false);
  const [productFormData, setProductFormData] = useState({
    product_name: "",
    sku: "",
    price: "",
    quantity: "",
    web_link: "",
    tags: "",
    notes: "",
    image: null,
    image_base64: "",
  });
  const [productImagePreview, setProductImagePreview] = useState(null);
  // Mutare folder/produs dialog state
  const [moveDialogOpen, setMoveDialogOpen] = useState(false);
  const [moveTargets, setMoveTargets] = useState([]);
  const [selectedMoveTargetId, setSelectedMoveTargetId] = useState(null);
  const [searchText, setSearchText] = useState("");
  // Bara de căutare produse
  const [searchTerm, setSearchTerm] = useState("");
  const [isLayer1, setIsLayer1] = useState(false);
  const [syncingProductId, setSyncingProductId] = useState(null);
  const open = Boolean(anchorEl);
  const navigate = useNavigate();
  const { groupId } = useParams();

  useEffect(() => {
    fetchData();
    const fetchGroup = async () => {
      try {
        const res = await axios.get(
          `https://server-9p4hx.kinsta.app/api/stocmanager/folders/${groupId}`,
        );
        setGroupName(res.data.name);
      } catch (err) {
        console.error("Eroare la fetch folder group:", err);
      }
    };
    fetchGroup();
  }, []);

  // Fetch move targets (toate folderele pentru mutare)
  const fetchMoveTargets = async () => {
    try {
      const res = await axios.get(
        "https://server-9p4hx.kinsta.app/api/stocmanager/folders",
      );
      setMoveTargets(res.data);
    } catch (err) {
      setMoveTargets([]);
    }
  };

  const handleSyncProduct = async (product) => {
    if (!product?.id) return;
    if (!product.sku || !String(product.sku).trim()) {
      window.alert("Produsul nu are SKU completat pentru sincronizare.");
      return;
    }
    setSyncingProductId(product.id);
    try {
      const { data } = await axios.post(
        `https://server-9p4hx.kinsta.app/api/stocmanager/products/${product.id}/sync`,
        { sku: product.sku },
      );
      setProducts((prev) =>
        prev.map((item) =>
          item.id === product.id
            ? {
                ...item,
                web_link: data?.web_link ?? item.web_link,
                image_url: data?.image_url ?? item.image_url,
                price:
                  data?.price !== undefined && data?.price !== null
                    ? data.price
                    : item.price,
              }
            : item,
        ),
      );
      setSelectedProduct((prev) =>
        prev && prev.id === product.id
          ? {
              ...prev,
              web_link: data?.web_link ?? prev.web_link,
              image_url: data?.image_url ?? prev.image_url,
              price:
                data?.price !== undefined && data?.price !== null
                  ? data.price
                  : prev.price,
            }
          : prev,
      );
      window.alert("Sincronizare realizată cu succes.");
    } catch (error) {
      console.error("Eroare sincronizare produs:", error);
      const message =
        error?.response?.data?.error ||
        "Nu am reușit să sincronizăm produsul. Încearcă din nou.";
      window.alert(message);
    } finally {
      setSyncingProductId(null);
    }
  };

  const fetchData = async () => {
    try {
      // Detectăm dacă groupId e Layer 1 sau Layer 2
      const groupDetails = await axios.get(
        `https://server-9p4hx.kinsta.app/api/stocmanager/folders/${groupId}`,
      );
      const isLayer1Val = !groupDetails.data.parent_id;
      setIsLayer1(isLayer1Val);

      const [summaryRes, foldersRes, productsRes] = await Promise.all([
        axios.get(
          `https://server-9p4hx.kinsta.app/api/stocmanager/summary?${isLayer1Val ? "parentId" : "folderId"}=${groupId}`,
        ),
        axios.get(
          `https://server-9p4hx.kinsta.app/api/stocmanager/folders/previews?parentId=${groupId}`,
        ),
        axios.get(
          `https://server-9p4hx.kinsta.app/api/stocmanager/folders/${groupId}/products`,
        ),
      ]);
      setSummary(summaryRes.data);
      setFolders(foldersRes.data);
      setProducts(productsRes.data);
    } catch (err) {
      console.error("Eroare la încărcarea datelor:", err);
    }
  };

  const handleCreateFolder = async () => {
    if (!newFolderName.trim()) return;
    try {
      const parentIdValue = Number(groupId);
      console.log("[📤 TRIMIT parent_id]:", parentIdValue);

      await axios.post(
        "https://server-9p4hx.kinsta.app/api/stocmanager/folders",
        {
          name: newFolderName,
          parent_id: parentIdValue,
        },
      );
      setNewFolderName("");
      setDialogOpen(false);
      setSnackbarOpen(true);
      fetchData(); // reîncarcă lista de foldere
    } catch (err) {
      console.error("Eroare creare folder:", err);
    }
  };

  const updateFolderName = async (id) => {
    try {
      await axios.put(
        `https://server-9p4hx.kinsta.app/api/stocmanager/folders/${id}`,
        {
          name: editedName,
        },
      );
      setEditingId(null);
      fetchData();
    } catch (err) {
      console.error("Eroare redenumire:", err);
    }
  };

  const handleAddProduct = async () => {
    try {
      const folderId = selectedFolder?.id || Number(groupId);
      console.log(
        "⛳ Trimit produs în folder_id:",
        folderId,
        "| selectedFolder:",
        selectedFolder,
        "| groupId:",
        groupId,
      );

      if (!folderId || isNaN(folderId)) {
        alert("ID folder invalid. Nu se poate salva produsul.");
        return;
      }

      const check = await axios.get(
        `https://server-9p4hx.kinsta.app/api/stocmanager/folders/${folderId}`,
      );
      if (!check.data?.id)
        throw new Error("Folderul nu există în baza de date");

      const formData = new FormData();
      formData.append("product_name", productFormData.product_name);
      formData.append("sku", productFormData.sku);
      formData.append("price", productFormData.price);
      formData.append("quantity", productFormData.quantity);
      formData.append("web_link", productFormData.web_link);
      formData.append("tags", productFormData.tags);
      formData.append("notes", productFormData.notes);
      formData.append("folder_id", folderId);

      if (productFormData.image_base64) {
        const byteString = atob(productFormData.image_base64.split(",")[1]);
        const mimeString = productFormData.image_base64
          .split(",")[0]
          .split(":")[1]
          .split(";")[0];
        const ab = new ArrayBuffer(byteString.length);
        const ia = new Uint8Array(ab);
        for (let i = 0; i < byteString.length; i++) {
          ia[i] = byteString.charCodeAt(i);
        }
        const blob = new Blob([ab], { type: mimeString });
        formData.append("image", blob, "upload.jpg");
      }

      await axios.post(
        "https://server-9p4hx.kinsta.app/api/stocmanager/products/upload-image",
        formData,
        {
          headers: { "Content-Type": "multipart/form-data" },
        },
      );

      setProductDialogOpen(false);
      setProductFormData({
        product_name: "",
        sku: "",
        price: "",
        quantity: "",
        web_link: "",
        tags: "",
        notes: "",
        image: null,
      });
      fetchData();
    } catch (err) {
      console.error("Eroare la adăugare produs:", err);
      alert("Eroare: folderul nu există sau a fost șters.");
    }
  };

  return (
    <Container
      disableGutters
      sx={{
        pt: 2,
        px: "calc(3 * 8px - 25px)", // similar cu MobileFolderProducts
        width: "100vw",
        maxWidth: "100vw",
        overflowX: "hidden",
      }}
    >
      <Box sx={{ transform: "translateX(-15px)", pr: 0 }}>
        <Box
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          px={2}
          mb={2}
        >
          <Typography
            variant="subtitle1"
            fontWeight="bold"
            sx={{ letterSpacing: 1, color: "text.primary" }}
          >
            {groupName}
          </Typography>
          <IconButton onClick={() => navigate("/")}>
            <ArrowBackIosNewIcon fontSize="small" />
          </IconButton>
        </Box>

        {isLayer1 && (
          <Paper sx={{ p: 2, mb: 2 }}>
            <Grid
              container
              spacing={1}
              alignItems="center"
              justifyContent="space-between"
            >
              <Grid item>
                <Typography fontSize={11}>Items</Typography>
                <Typography fontWeight="bold">{summary.items || 0}</Typography>
              </Grid>
              <Grid item>
                <Typography fontSize={11}>Produse</Typography>
                <Typography fontWeight="bold">{summary.products}</Typography>
              </Grid>
              <Grid item>
                <Typography fontSize={11}>Folders</Typography>
                <Typography fontWeight="bold">{summary.folders}</Typography>
              </Grid>
              <Grid item>
                <Typography fontSize={11} align="center">
                  Total Value
                </Typography>
                <Typography
                  fontWeight="bold"
                  align="center"
                  sx={{ whiteSpace: "nowrap" }}
                >
                  {Math.round(summary.totalValue).toLocaleString()} RON
                </Typography>
              </Grid>
            </Grid>
          </Paper>
        )}

        {/* Bara de căutare produse */}
        <TextField
          placeholder="Caută după denumire sau SKU"
          variant="outlined"
          margin="dense"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
            sx: { borderRadius: 3, backgroundColor: "#fafafa" },
          }}
          sx={{ mb: 2, ml: 1.7, width: "calc(100% - 19px)" }}
        />

        {folders.map((folder) => (
          <Paper
            key={folder.id}
            sx={{
              p: 2,
              mb: 2,
              border:
                folder.id === Number(groupId)
                  ? "2px dashed #1976d2"
                  : undefined,
              backgroundColor:
                folder.id === Number(groupId) ? "#e3f2fd" : undefined,
              ml: 0,
              minHeight: 100,
            }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
              }}
            >
              {/* Eliminat StorefrontIcon */}
              <Box
                sx={{
                  display: "grid",
                  gridTemplateColumns: "repeat(2, 1fr)",
                  gap: 0.5,
                  minWidth: 80,
                  flexShrink: 0,
                }}
              >
                {Array.from({ length: 4 }).map((_, idx) => {
                  const img = folder.previewImages?.[idx];
                  return img ? (
                    <Box
                      key={idx}
                      component="img"
                      src={img}
                      sx={{
                        width: 42,
                        height: 42,
                        borderRadius: 1,
                        objectFit: "cover",
                        background: "#fafafa",
                      }}
                    />
                  ) : (
                    <Box
                      key={idx}
                      sx={{
                        width: 42,
                        height: 42,
                        borderRadius: 1,
                        backgroundColor: "#e0e0e0",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <PhotoCameraIcon
                        sx={{ fontSize: 18, color: "#9e9e9e" }}
                      />
                    </Box>
                  );
                })}
              </Box>
              <Box
                sx={{
                  flex: 1,
                  display: "flex",
                  flexDirection: "column",
                  minWidth: 0,
                }}
              >
                {folder.id === Number(groupId) && (
                  <Typography
                    fontSize={12}
                    fontStyle="italic"
                    color="primary.main"
                  >
                    Produs direct în această categorie
                  </Typography>
                )}
                <Box
                  onClick={() => {
                    if (editingId !== folder.id)
                      navigate(`/folder/${folder.id}`);
                  }}
                  sx={{ cursor: "pointer", flexGrow: 1, ml: 2.1 }}
                >
                  {editingId === folder.id ? (
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                      <TextField
                        variant="standard"
                        value={editedName}
                        onChange={(e) => setEditedName(e.target.value)}
                        sx={{ flexGrow: 1 }}
                        autoFocus
                      />
                      <IconButton onClick={() => updateFolderName(folder.id)}>
                        <CheckIcon fontSize="large" />
                      </IconButton>
                    </Box>
                  ) : (
                    <Typography fontWeight="bold" fontSize={13}>
                      {folder.name}
                    </Typography>
                  )}
                  <Typography fontSize={11} color="text.secondary">
                    {folder.totalProducts || 0} produse |{" "}
                    {folder.totalValue ? folder.totalValue.toLocaleString() : 0}{" "}
                    RON
                  </Typography>
                </Box>
              </Box>
              <IconButton
                onClick={(e) => {
                  setAnchorEl(e.currentTarget);
                  setSelectedFolder(folder);
                }}
                sx={{ ml: "auto" }}
              >
                <MoreVertIcon />
              </IconButton>
            </Box>
          </Paper>
        ))}
        {products
          .filter(
            (p) =>
              p.product_name
                ?.toLowerCase()
                .includes(searchTerm.toLowerCase()) ||
              p.sku?.toLowerCase().includes(searchTerm.toLowerCase()),
          )
          .map((product) => (
            <Paper
              key={product.id}
              sx={{
                p: 2,
                mb: 2,
                borderLeft: "4px solid #4caf50",
                cursor: "pointer",
                ...(product.quantity === 0
                  ? { boxShadow: "0 0 12px 2px rgba(255, 0, 0, 0.5)" }
                  : {}),
              }}
              onClick={() => navigate(`/mobile-product/${product.id}`)}
            >
              <Box display="flex" flexDirection="row" alignItems="center">
                <Box sx={{ display: "flex", gap: 2, width: "auto" }}>
                  <Box
                    sx={{
                      width: 85,
                      aspectRatio: "1 / 1",
                      borderRadius: 1,
                      backgroundColor: "#f5f5f5",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      overflow: "hidden",
                    }}
                  >
                    {product.image_url ? (
                      <Box
                        component="img"
                        src={product.image_url}
                        loading="lazy"
                        alt={product.product_name}
                        sx={{
                          width: "100%",
                          height: "100%",
                          objectFit: "cover",
                          display: "block",
                        }}
                      />
                    ) : (
                      <Box
                        sx={{
                          width: 120,
                          height: "100%",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          backgroundColor: "#e0e0e0",
                        }}
                      >
                        <PhotoCameraIcon
                          sx={{ fontSize: 40, color: "#9e9e9e" }}
                        />
                      </Box>
                    )}
                  </Box>
                </Box>

                <Box sx={{ ml: 2 }}>
                  <Typography
                    fontWeight="bold"
                    sx={{
                      display: "-webkit-box",
                      WebkitLineClamp: 2,
                      WebkitBoxOrient: "vertical",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                    }}
                  >
                    {product.product_name}
                  </Typography>
                  <Typography
                    variant="caption"
                    color="text.secondary"
                    sx={{ mt: 0.5, display: "block" }}
                  >
                    Preț: {Number(product.price).toLocaleString()} RON — SKU:{" "}
                    {product.sku}
                  </Typography>
                </Box>
                <IconButton
                  onClick={(e) => {
                    e.stopPropagation();
                    setAnchorEl(e.currentTarget);
                    setSelectedProduct(product);
                  }}
                >
                  <MoreVertIcon />
                </IconButton>
              </Box>
            </Paper>
          ))}
        <Menu anchorEl={anchorEl} open={open} onClose={() => setAnchorEl(null)}>
          {selectedFolder && (
            <>
              <MenuItem
                onClick={() => {
                  setAnchorEl(null);
                  if (selectedFolder) {
                    setEditingId(selectedFolder.id);
                    setEditedName(selectedFolder.name);
                  }
                }}
              >
                <EditIcon fontSize="small" sx={{ mr: 1 }} /> Edit
              </MenuItem>
              <MenuItem
                onClick={() => {
                  setAnchorEl(null);
                  console.log("Clonare folder", selectedFolder?.id); // Placeholder
                }}
              >
                <ContentCopyIcon fontSize="small" sx={{ mr: 1 }} /> Clonează
              </MenuItem>
              <MenuItem
                onClick={() => {
                  setAnchorEl(null);
                  fetchMoveTargets();
                  setMoveDialogOpen(true);
                }}
              >
                <DriveFileMoveIcon fontSize="small" sx={{ mr: 1 }} /> Mută
              </MenuItem>
              <MenuItem
                onClick={async () => {
                  setAnchorEl(null);
                  if (selectedFolder) {
                    await axios.delete(
                      `https://server-9p4hx.kinsta.app/api/stocmanager/folders/${selectedFolder.id}`,
                    );
                    fetchData();
                  }
                }}
                sx={{ color: "error.main" }}
              >
                <DeleteIcon fontSize="small" sx={{ mr: 1 }} /> Delete
              </MenuItem>
            </>
          )}
          {selectedProduct && (
            <>
              <MenuItem
                onClick={async () => {
                  const productToSync = selectedProduct;
                  setAnchorEl(null);
                  if (productToSync) {
                    await handleSyncProduct(productToSync);
                  }
                }}
                disabled={
                  syncingProductId !== null &&
                  selectedProduct &&
                  syncingProductId === selectedProduct.id
                }
              >
                <AutorenewIcon fontSize="small" sx={{ mr: 1 }} />
                {syncingProductId === selectedProduct?.id
                  ? "Sincronizare..."
                  : "Sync"}
              </MenuItem>
              <MenuItem
                onClick={() => {
                  navigate(`/mobile-product/${selectedProduct.id}`);
                  setAnchorEl(null);
                }}
              >
                <EditIcon fontSize="small" sx={{ mr: 1 }} /> Detalii
              </MenuItem>
              <MenuItem
                onClick={() => {
                  if (selectedProduct) {
                    setProductFormData({
                      product_name: `${selectedProduct.product_name} (copie)`,
                      sku: selectedProduct.sku,
                      price: selectedProduct.price,
                      quantity: selectedProduct.quantity,
                      web_link: selectedProduct.web_link,
                      tags: selectedProduct.tags,
                      notes: selectedProduct.notes,
                      image_base64: selectedProduct.image_base64,
                    });
                    setProductDialogOpen(true);
                  }
                  setAnchorEl(null);
                }}
              >
                <ContentCopyIcon fontSize="small" sx={{ mr: 1 }} /> Clonează
              </MenuItem>
              <MenuItem
                onClick={() => {
                  setAnchorEl(null);
                  fetchMoveTargets();
                  setMoveDialogOpen(true);
                }}
              >
                <DriveFileMoveIcon fontSize="small" sx={{ mr: 1 }} /> Mută
              </MenuItem>
              <MenuItem
                onClick={async () => {
                  await axios.delete(
                    `https://server-9p4hx.kinsta.app/api/stocmanager/products/${selectedProduct.id}`,
                  );
                  setAnchorEl(null);
                  fetchData();
                }}
                sx={{ color: "error.main" }}
              >
                <DeleteIcon fontSize="small" sx={{ mr: 1 }} /> Șterge
              </MenuItem>
            </>
          )}
        </Menu>
        {/* Dialog Mutare Folder sau Produs */}
        <Dialog
          fullScreen
          open={moveDialogOpen}
          onClose={() => setMoveDialogOpen(false)}
        >
          <DialogTitle sx={{ px: 2, pt: 2, pb: 1 }}>
            Mutare în altă Gestiune
          </DialogTitle>
          <DialogContent sx={{ p: 2 }}>
            <TextField
              fullWidth
              placeholder="Caută gestiune..."
              value={searchText}
              onChange={(e) => setSearchText(e.target.value)}
              sx={{ mb: 2 }}
            />
            <Box sx={{ maxHeight: "60vh", overflowY: "auto" }}>
              {moveTargets
                .filter((layer1) => {
                  const subfolders = moveTargets.filter(
                    (sub) =>
                      sub.parent_id === layer1.id &&
                      sub.name
                        .toLowerCase()
                        .includes(searchText.toLowerCase()) &&
                      sub.id !== selectedFolder?.id &&
                      sub.id !== selectedProduct?.folder_id,
                  );

                  const isLayer1Match =
                    layer1.name
                      .toLowerCase()
                      .includes(searchText.toLowerCase()) &&
                    layer1.id !== selectedFolder?.id &&
                    layer1.id !== selectedProduct?.folder_id;

                  return isLayer1Match || subfolders.length > 0;
                })
                .map((layer1) => {
                  const subfolders = moveTargets.filter(
                    (sub) =>
                      sub.parent_id === layer1.id &&
                      sub.name
                        .toLowerCase()
                        .includes(searchText.toLowerCase()) &&
                      sub.id !== selectedFolder?.id &&
                      sub.id !== selectedProduct?.folder_id,
                  );

                  const isLayer1Match =
                    layer1.name
                      .toLowerCase()
                      .includes(searchText.toLowerCase()) &&
                    layer1.id !== selectedFolder?.id &&
                    layer1.id !== selectedProduct?.folder_id;

                  return (
                    <Box key={layer1.id} sx={{ mb: 2 }}>
                      {isLayer1Match && (
                        <Paper
                          onClick={() => setSelectedMoveTargetId(layer1.id)}
                          sx={{
                            p: 1.5,
                            mb: 0.5,
                            cursor: "pointer",
                            bgcolor:
                              selectedMoveTargetId === layer1.id
                                ? "#e3f2fd"
                                : "#fff",
                            borderLeft: "4px solid #1976d2",
                          }}
                        >
                          <Box sx={{ display: "flex", alignItems: "center" }}>
                            <Box
                              sx={{
                                minWidth: 60,
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                mr: 1,
                              }}
                            >
                              <StorefrontIcon
                                color="primary"
                                sx={{ fontSize: 38 }}
                              />
                            </Box>
                            <Box>
                              <Typography fontWeight="bold">
                                {layer1.name}
                              </Typography>
                              <Typography
                                variant="caption"
                                color="text.secondary"
                              >
                                Gestiune principală (Layer 1)
                              </Typography>
                            </Box>
                          </Box>
                        </Paper>
                      )}

                      {subfolders.map((sub) => (
                        <Paper
                          key={sub.id}
                          onClick={() => setSelectedMoveTargetId(sub.id)}
                          sx={{
                            ml: 4,
                            p: 1.5,
                            mb: 0.5,
                            cursor: "pointer",
                            bgcolor:
                              selectedMoveTargetId === sub.id
                                ? "#f3e5f5"
                                : "#f9f9f9",
                            borderLeft: "4px solid #9c27b0",
                          }}
                        >
                          <Box sx={{ display: "flex", alignItems: "center" }}>
                            <Box
                              sx={{
                                minWidth: 60,
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                mr: 1,
                              }}
                            >
                              <StorefrontIcon
                                color="secondary"
                                sx={{ fontSize: 38 }}
                              />
                            </Box>
                            <Box>
                              <Typography fontWeight="bold">
                                {sub.name}
                              </Typography>
                              <Typography
                                variant="caption"
                                color="text.secondary"
                              >
                                Subfolder (Layer 2)
                              </Typography>
                            </Box>
                          </Box>
                        </Paper>
                      ))}
                    </Box>
                  );
                })}
            </Box>
          </DialogContent>
          <DialogActions
            sx={{
              display: "flex",
              justifyContent: "space-between",
              gap: 2,
              mt: 1,
              mb: 3.5,
              px: 2,
            }}
          >
            <Button
              onClick={() => setMoveDialogOpen(false)}
              startIcon={<CloseIcon />}
              variant="outlined"
              color="secondary"
              sx={{ flex: 1 }}
            >
              Anulează
            </Button>
            <Button
              variant="contained"
              disabled={!selectedMoveTargetId}
              startIcon={<CheckIcon />}
              onClick={async () => {
                try {
                  if (selectedFolder) {
                    await axios.put(
                      `https://server-9p4hx.kinsta.app/api/stocmanager/folders/${selectedFolder.id}`,
                      {
                        parent_id: selectedMoveTargetId,
                      },
                    );
                  } else if (selectedProduct) {
                    await axios.put(
                      `https://server-9p4hx.kinsta.app/api/stocmanager/products/${selectedProduct.id}`,
                      {
                        folder_id: selectedMoveTargetId,
                      },
                    );
                  }
                  setMoveDialogOpen(false);
                  setSelectedMoveTargetId(null);
                  setSelectedFolder(null);
                  setSelectedProduct(null);
                  fetchData();
                } catch (err) {
                  alert("Eroare la mutare!");
                  console.error("Eroare mutare:", err);
                }
              }}
              sx={{ flex: 1 }}
            >
              Confirmă
            </Button>
          </DialogActions>
        </Dialog>
      </Box>

      <SpeedDial
        ariaLabel="Adaugă"
        sx={{
          position: "fixed",
          bottom: 100,
          right: 20,
          zIndex: 9999,
          transform: "scale(1)",
          transition: "transform 0.3s ease-in-out",
          "&:hover": {
            transform: "scale(1.1)",
          },
        }}
        icon={<SpeedDialIcon />}
      >
        <SpeedDialAction
          icon={<FolderIcon />}
          tooltipTitle={<Typography variant="caption">Gestiune</Typography>}
          tooltipOpen
          onClick={() => setDialogOpen(true)}
        />
        <SpeedDialAction
          icon={<InventoryIcon />}
          tooltipTitle={<Typography variant="caption">Produs</Typography>}
          tooltipOpen
          onClick={() => setProductDialogOpen(true)}
        />
      </SpeedDial>

      <Dialog
        open={dialogOpen}
        onClose={() => setDialogOpen(false)}
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle>Adaugă Gestiune Noua</DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            margin="dense"
            label="Nume Gestiune"
            fullWidth
            value={newFolderName}
            onChange={(e) => setNewFolderName(e.target.value)}
          />
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => setDialogOpen(false)}
            startIcon={<CloseIcon />}
            color="secondary"
          >
            Anulează
          </Button>
          <Button
            onClick={handleCreateFolder}
            variant="contained"
            startIcon={<SaveIcon />}
          >
            Salvează s
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={productDialogOpen}
        onClose={() => setProductDialogOpen(false)}
        fullScreen
      >
        <DialogTitle>Adaugă Produs</DialogTitle>
        <DialogContent>
          <Box
            component="label"
            sx={{
              border: "2px dashed #ccc",
              height: 180,
              borderRadius: 2,
              mb: 2,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              backgroundColor: "#f9f9f9",
              overflow: "hidden",
              cursor: "pointer",
            }}
          >
            <input
              type="file"
              hidden
              accept="image/*"
              onChange={(e) => {
                const file = e.target.files[0];
                if (!file) return;
                const reader = new FileReader();
                reader.onloadend = () => {
                  setProductFormData((prev) => ({
                    ...prev,
                    image_base64: reader.result,
                  }));
                };
                reader.readAsDataURL(file);
              }}
            />
            {productFormData.image_base64 ? (
              <Box
                component="img"
                src={productFormData.image_base64}
                sx={{ width: "100%", height: "100%", objectFit: "cover" }}
              />
            ) : (
              <Box textAlign="center">
                <PhotoCameraIcon sx={{ fontSize: 32, color: "#999" }} />
                <Typography variant="caption" display="block">
                  Încarcă imagine
                </Typography>
              </Box>
            )}
          </Box>

          <TextField
            fullWidth
            margin="dense"
            label="Nume produs"
            value={productFormData.product_name}
            onChange={(e) =>
              setProductFormData({
                ...productFormData,
                product_name: e.target.value,
              })
            }
          />
          <Grid container spacing={1}>
            <Grid item xs={6}>
              <TextField
                fullWidth
                label="Cantitate"
                type="number"
                value={productFormData.quantity}
                onChange={(e) =>
                  setProductFormData({
                    ...productFormData,
                    quantity: e.target.value,
                  })
                }
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                fullWidth
                label="Preț (€)"
                type="number"
                value={productFormData.price}
                onChange={(e) =>
                  setProductFormData({
                    ...productFormData,
                    price: e.target.value,
                  })
                }
              />
            </Grid>
          </Grid>
          <Grid container spacing={1}>
            <Grid item xs={6}>
              <TextField
                fullWidth
                label="SKU"
                value={productFormData.sku}
                sx={{ backgroundColor: "#f8e5f8" }}
                onChange={(e) =>
                  setProductFormData({
                    ...productFormData,
                    sku: e.target.value,
                  })
                }
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                fullWidth
                label="Tags"
                value={productFormData.tags}
                onChange={(e) =>
                  setProductFormData({
                    ...productFormData,
                    tags: e.target.value,
                  })
                }
              />
            </Grid>
          </Grid>
          <TextField
            fullWidth
            margin="dense"
            label="Notițe"
            multiline
            value={productFormData.notes}
            onChange={(e) =>
              setProductFormData({ ...productFormData, notes: e.target.value })
            }
          />
          <TextField
            fullWidth
            margin="dense"
            label="Web Link"
            value={productFormData.web_link}
            sx={{ backgroundColor: "#f8e5f8" }}
            onChange={(e) =>
              setProductFormData({
                ...productFormData,
                web_link: e.target.value,
              })
            }
          />
        </DialogContent>
        <DialogActions
          sx={{
            display: "flex",
            justifyContent: "space-between",
            gap: 2,
            mt: 1,
            mb: 3.5,
            px: 2,
          }}
        >
          <Button
            onClick={() => setProductDialogOpen(false)}
            startIcon={<CloseIcon />}
            variant="outlined"
            color="secondary"
            fullWidth
            sx={{ flex: 1 }}
          >
            Anulează
          </Button>
          <Button
            variant="contained"
            onClick={handleAddProduct}
            startIcon={<SaveIcon />}
            fullWidth
            sx={{ flex: 1 }}
          >
            Salvează
          </Button>
        </DialogActions>
      </Dialog>

      <Snackbar
        open={snackbarOpen}
        autoHideDuration={3000}
        onClose={() => setSnackbarOpen(false)}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert
          onClose={() => setSnackbarOpen(false)}
          severity="success"
          sx={{ width: "100%" }}
        >
          Folderul a fost creat cu succes!
        </Alert>
      </Snackbar>
    </Container>
  );
}

export default MobileStocManager;
